import storageKeys from 'src/app_config/storage-keys.json';

export function clearLocalStorage() {
	if (typeof window !== 'undefined') {
		localStorage.removeItem(storageKeys.LocalStorage.RecentlyEnrolledCourses);
	}
}
